import { storeToRefs } from "pinia";
import { onMounted, onUnmounted, watch } from "vue";
import { useRoute } from "vue-router";

import ModalService from "shared/modals/ModalService";
import { addShortcutList, removeShortcutList } from "shared/services/shortcuts";
import { useUserStore } from "shared/stores/user";

export default function modal(name: string) {
  const route = useRoute();
  const { isLoggedIn } = storeToRefs(useUserStore());

  function close() {
    ModalService.close(name);
  }

  watch(isLoggedIn, () => {
    if (!isLoggedIn.value) {
      ModalService.closeAll();
    }
  });

  watch(
    () => route,
    (newRoute, prevRoute) => {
      // Allow modals to be opened immediately after login
      if (prevRoute?.name === "login") {
        return;
      }

      ModalService.closeAll();
    }
  );

  const shortcuts = [
    {
      key: "Escape",
      callback: close,
    },
  ];

  onMounted(() => {
    addShortcutList(shortcuts);
  });

  onUnmounted(() => {
    removeShortcutList(shortcuts);
  });

  return { close };
}
